import { __awaiter, __generator } from "tslib";
import { listDataExtensionSchemas } from '@wix/ambassador-data-extensions-v1-data-extension-schema/http';
import { RequestedField } from '@wix/ambassador-data-extensions-v1-data-extension-schema/types';
export var USER_DEFINED_FIELDS_NAMESPACE = '_user_fields';
export var CHECKOUT_FQDN = 'wix.ecom.*.checkout';
export var dataExtensionSchemasRequestData = {
    fqdn: CHECKOUT_FQDN,
    namespaces: [USER_DEFINED_FIELDS_NAMESPACE],
    fields: [RequestedField.UNKNOWN_REQUESTED_FIELD, RequestedField.ARCHIVED],
};
export var ambassadorRequestOptionsFactory = listDataExtensionSchemas;
var DataExtensionsApi = /** @class */ (function () {
    function DataExtensionsApi(_a) {
        var httpClient = _a.httpClient;
        this.httpClient = httpClient;
    }
    DataExtensionsApi.prototype.fetchUserDefinedDataExtensionsSchema = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, userDefinedFieldsSchema;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.request(ambassadorRequestOptionsFactory(dataExtensionSchemasRequestData))];
                    case 1:
                        response = _a.sent();
                        userDefinedFieldsSchema = response.data.dataExtensionSchemas
                            ? response.data.dataExtensionSchemas.find(function (schema) { return schema.namespace === USER_DEFINED_FIELDS_NAMESPACE; })
                            : /* istanbul ignore next */ undefined;
                        return [2 /*return*/, userDefinedFieldsSchema ? userDefinedFieldsSchema : undefined];
                }
            });
        });
    };
    return DataExtensionsApi;
}());
export { DataExtensionsApi };
//# sourceMappingURL=DataExtensionsApi.js.map